module.exports = __webpack_public_path__ + "static/img/webpage.bb5c942.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/webpage.png
// module id = 550g
// module chunks = 0